import { useCallback, useEffect, useRef, useState } from "react";

import { useClickOutside } from "./Shell";

/** "Who is Speaker 2?": pick one of the meeting's invitees, type a name, or
 * say you're not sure, which shows the label again. Opens under the name that
 * was clicked; saving renames that voice on every line. */
export function SpeakerMenu({ label, current, candidates, saving, error, onSave, onClose }: {
  label: string;
  current: string | null;
  candidates: string[];
  saving: boolean;
  error: string | null;
  onSave: (name: string | null) => void;
  onClose: () => void;
}) {
  const [typed, setTyped] = useState("");
  const box = useRef<HTMLDivElement>(null);
  const close = useCallback(() => onClose(), [onClose]);
  useClickOutside(box, true, close);
  useEffect(() => box.current?.querySelector<HTMLElement>("button, input")?.focus(), []);

  return (
    <div className="speaker-menu" ref={box} role="dialog" aria-label={`Who is ${label}?`}>
      <p className="speaker-menu-title">Who is {label}?</p>
      {candidates.length > 0 && (
        <ul>
          {candidates.map((name) => (
            <li key={name}>
              <button className={name === current ? "on" : undefined} disabled={saving} onClick={() => onSave(name)}>
                {name}
              </button>
            </li>
          ))}
        </ul>
      )}
      <form
        className="speaker-menu-type"
        onSubmit={(event) => {
          event.preventDefault();
          if (typed.trim()) onSave(typed.trim());
        }}
      >
        <input
          value={typed}
          onChange={(event) => setTyped(event.target.value)}
          placeholder="Someone else: type a name"
          aria-label="Type a name"
          maxLength={80}
        />
        <button className="btn-primary" type="submit" disabled={!typed.trim() || saving}>Save</button>
      </form>
      <div className="speaker-menu-foot">
        <button className="btn-text" disabled={saving} onClick={() => onSave(null)}>Not sure — show “{label}”</button>
        <button className="btn-text" onClick={onClose}>Cancel</button>
      </div>
      {saving && <p className="speaker-menu-note">Saving…</p>}
      {error && <p className="speaker-menu-note error-text">{error}</p>}
      <p className="speaker-menu-note">Changes the name on every line, for everyone. The minutes are rewritten with it a minute later.</p>
    </div>
  );
}
